export enum WaveWrapperModeEnum {
  WRAPPED = 'wrapped',
  BACKGROUND = 'background',
}

export const getWaveWrapperModeValues = () => Object.values(WaveWrapperModeEnum) as [string, ...string[]];
